import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import { BackResponse, FileSummary } from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.workflow}files/customerFile/summaries`;

export interface GetCustomerFilesFullSummariesQueryArgs {
  fileIds: string[];
}

export const getCustomerFilesFullSummariesRequest = (
  payload: GetCustomerFilesFullSummariesQueryArgs,
): ApiRequestDescriptor => ({
  url: buildUrl(ENDPOINT, { fileIds: payload.fileIds }),
  config: { method: SUPPORTED_METHODS.GET },
});

export const getCustomerFilesFullSummariesQuery = async (
  payload: GetCustomerFilesFullSummariesQueryArgs,
) => {
  try {
    return await executeQuery<BackResponse<FileSummary[]>>(
      getCustomerFilesFullSummariesRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
